import http, { API_PREFIX } from './http'
import type {
  LoginRequest,
  TokenResponse,
  UserInfo,
  AuthConfig,
  SetupRequest,
  SetupResponse,
  RegisterRequest,
  RegisterResponse,
} from '@/models/Auth'

export const authApi = {
  login: (data: LoginRequest) => http.post<TokenResponse>(`${API_PREFIX}/auth/login`, data),
  refresh: (refreshToken: string) =>
    http.post<TokenResponse>(`${API_PREFIX}/auth/refresh`, { refresh_token: refreshToken }),
  getCurrentUser: () => http.get<UserInfo>(`${API_PREFIX}/auth/me`),
  getAuthConfig: () => http.get<AuthConfig>(`${API_PREFIX}/auth/config`),
  completeSetup: (data: SetupRequest) => http.post<SetupResponse>(`${API_PREFIX}/auth/setup`, data),
  register: (data: RegisterRequest) =>
    http.post<RegisterResponse>(`${API_PREFIX}/auth/register`, data),
}
